import * as React from 'react';
import { Box, Fade, LinearProgress } from '@mui/material';

export default function Loading(props) {
    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Fade
                    in={props.isShow}
                    style={{
                        transitionDelay: props.isShow ? '800ms' : '0ms',
                    }}
                    unmountOnExit>
                    <LinearProgress />
                </Fade>
            </Box>
        </>
    );
}